import {INTER_PILL_SPACER} from './constants'


// True if `node` is one of our zero-width spacer text nodes — a text
// node whose entire content is a single INTER_PILL_SPACER (U+200B).
//
// Spacers are always their own standalone text node (never merged into
// real text), which is what makes them safe to detect, strip and rebuild
// by exact match. Used by normalize-spacers (rebuild), the keydown
// handler (skip/delete past them), and the caret snapper.
export function textareaWithVariables_isSpacer(node: Node | null): boolean {
    return !!node
        && node.nodeType === Node.TEXT_NODE
        && node.textContent === INTER_PILL_SPACER
}
